import * as React from 'react';
import type { PiletApi } from '@chess/platform-web';

/** An API by name, once its provider has registered it; undefined until then. */
export function useApi<T>(app: PiletApi, name: string): T | undefined {
  const [api, setApi] = React.useState<T | undefined>(() => app.tryGetApi<T>(name));
  React.useEffect(() => {
    if (api) return;
    let alive = true;
    void app.getApi<T>(name).then((a) => alive && setApi(a));
    return () => {
      alive = false;
    };
  }, [app, name, api]);
  return api;
}
